import axios from "axios";

export const portalApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

export const portalErr = (err) => {
  const detail = err.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return "Something went wrong. Please try again.";
};

export const downloadFile = async (path, filename) => {
  const { data } = await portalApi.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};

export const openPdf = async (path) => {
  const { data } = await portalApi.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
  window.open(url, "_blank", "noopener");
};

export const inr = (paise) => `₹${(paise / 100).toLocaleString("en-IN", { minimumFractionDigits: paise % 100 ? 2 : 0 })}`;

export const loadRazorpay = () => new Promise((resolve) => {
  if (window.Razorpay) return resolve(true);
  const script = document.createElement("script");
  script.src = "https://checkout.razorpay.com/v1/checkout.js";
  script.onload = () => resolve(true);
  script.onerror = () => resolve(false);
  document.body.appendChild(script);
});

// One-click SSO into the Homework app — mints a one-time bridge token and lands the
// student already logged in. Falls back to the plain homework login on any failure.
export const openHomework = async () => {
  try {
    const { data } = await portalApi.get("/portal/hw-bridge");
    window.location.href = data.url;
  } catch {
    window.location.href = "/homework";
  }
};
